import { Paginated } from '../common/types';
import axios from 'axios';
import { ADMIN_API_KEYS_ROUTE } from '../api/backend';
import {
  ApiKeyResponseDto,
  CreateAdminApiKeyDto,
  UpdateAdminApiKeyDto,
} from '../common/model/dto/api-key';

class ApiKeyService {
  public static readonly API_KEY_LIST_LIMIT: number = 10;

  static async getApiKeys(
    query: string
  ): Promise<Paginated<ApiKeyResponseDto>> {
    const { data } = await axios.get<ApiKeyResponseDto[]>(
      `${ADMIN_API_KEYS_ROUTE}?${query}`
    );

    // Backend returns array directly, so we need to wrap it in paginated format
    return {
      docs: data,
      total: data.length,
      limit: this.API_KEY_LIST_LIMIT,
      offset: 0,
    };
  }

  static async getApiKeyById(apiKeyId: string): Promise<ApiKeyResponseDto> {
    const { data } = await axios.get<ApiKeyResponseDto>(
      `${ADMIN_API_KEYS_ROUTE}/${apiKeyId}`
    );
    return data;
  }

  static async createApiKey(
    apiKey: CreateAdminApiKeyDto
  ): Promise<ApiKeyResponseDto> {
    const { data } = await axios.post<ApiKeyResponseDto>(
      ADMIN_API_KEYS_ROUTE,
      apiKey
    );
    return data;
  }

  static async updateApiKey(
    apiKeyId: string,
    apiKey: UpdateAdminApiKeyDto
  ): Promise<ApiKeyResponseDto> {
    const { data } = await axios.patch<ApiKeyResponseDto>(
      `${ADMIN_API_KEYS_ROUTE}/${apiKeyId}`,
      apiKey
    );
    return data;
  }

  static async revokeApiKey(
    apiKeyId: string,
    reason?: string
  ): Promise<ApiKeyResponseDto> {
    const { data } = await axios.patch<ApiKeyResponseDto>(
      `${ADMIN_API_KEYS_ROUTE}/${apiKeyId}/revoke`,
      { reason }
    );
    return data;
  }

  static async activateApiKey(apiKeyId: string): Promise<ApiKeyResponseDto> {
    const { data } = await axios.patch<ApiKeyResponseDto>(
      `${ADMIN_API_KEYS_ROUTE}/${apiKeyId}/activate`
    );
    return data;
  }

  static async deleteApiKey(apiKeyId: string): Promise<void> {
    return await axios.delete(`${ADMIN_API_KEYS_ROUTE}/${apiKeyId}`);
  }
}

export default ApiKeyService;
